import priceCheckerAPI from './../../../services/purchase/priceChecker'
import itemAPI from './../../../services/purchase/item';

export default {
    namespaced: true,
    state: {
        loading: false,
        itemID: null,
        data: [],
        items: [],
        itemsLoading: []
    },  
    mutations: {
        loading: (state, payload) => state.loading = payload,
        itemID: (state, payload) => state.itemID = payload,
        data: (state, payload) => state.data = payload,
        items: (state, payload) => state.items =  Array.from(new Set([...state.items, ...payload])),
        itemsLoading: (state, payload) => state.itemsLoading = payload
    },
    actions: {
        fetch({commit, state}) {
            commit("loading", true)
            commit("data", [])
            priceCheckerAPI.get({itemID: state.itemID}).then(response => {
                commit("data", response.data)
            }).finally(() => {
                commit("loading", false);
            })
        },
        searchItems({commit}, payload) {
            commit("itemsLoading", true);
            itemAPI.search(payload).then(response => {
                commit("items", response.data)
            }).finally(() => {
                commit("itemsLoading", false)
            })
        },
        setItemID({commit}, payload) {
            commit("itemID", payload)
        }
    }
}